import React from "react";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import IPDList from "./ipdList";

const IpdContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <IPDList />
       
      </div>
    </div>
  )
}

export default IpdContainer;
